module.exports = __webpack_public_path__ + "media/application/images/demo/top3-8e43f6273a587f2db26d76dda1a36be4.jpg";